import { ComboBoxItemTypeS } from "../../atoms/ComboBox/ItemComboBoxStr"
import dayjs from 'dayjs';
import { ResponceDataType } from "../../../ErrorCode";

export type SelectDataType = {
  devIndex: string; //選択機器番号
  selectDate: string; //選択日時
  selectTime: string; //選択時間
};

/**
 * オフライン判定データ
 */
export type OfflineJudgeDataType = {
  DEV_INDEX?: number;  /// 機器 INDEX を取得または設定します
  DEV_NO: string;  ///  機器番号を取得または設定します
  DEV_NAME: string;  ///  機器名称を取得または設定します
  PLC_NO: number;  ///PLCNo. を取得または設定します
  AI_CARD: number;  ///AI カード No. を取得または設定します
  AI_CH: number;  /// CHNo. を取得または設定します
  SET_NO?: number;  /// センサー No. を取得または設定します
  SPEED: number;  /// 低速/高速区分を取得または設定します
  NAME_NO: number;  /// 名称 No を取得または設定します
  MES_NAME: string;  /// 計測種別を取得または設定します
  ITM_NAME_NO: number;  /// 項目名称 No を取得または設定します
  ITM_NAME: string;  /// 項目名称を取得または設定します
};


//オフライン判定デバイス情報尾取得
export const GetOffLineJudgeData = (): Promise<OfflineJudgeDataType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/OfflineJudge/")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: OfflineJudgeDataType[]) => {
        if (result != null) {
          if (result.length !== 0) {
            console.debug(["GetOffLineJudgeData - ok",result]);
          }
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error.status);
        console.error(error);
        reject(error);
      })
  })
};

/**
 * オフライン判定データのファイル時間リストを取得
 * @param devIndex
 * @param date
 * @returns
 */
export const GetOffLineJudgeFileTimes = (devIndex : string , date : string ): Promise<Date[]> => {
  return new Promise((resolve, reject) => {

    const query_params = new URLSearchParams({
      devIndex: devIndex,
      selectDate: date
    });

    console.debug(["GetOffLineJudgeFileTimes - ulr","api/OfflineJudge/GetTime?" + query_params])
    fetch("api/OfflineJudge/GetTimes?" + query_params)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: Date[]) => {
        if (result != null) {
          if (result.length !== 0) {
            console.debug(["GetOffLineJudgeFileTimes - ok",result]);
          }
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

/**
 * オフライン判定データをコピー
 * @param devIndex
 * @param date
 * @returns
 */
export const ExecuteCopyOffLineJudgeFile = (devIndex : string , date : string ): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    const query_params = new URLSearchParams({
      devIndex: devIndex,
      selectDate: date
    });

    console.debug(["ExecuteCopyOffLineJudgeFile - ulr","api/OfflineJudge/CopyExecute?" + query_params])
    fetch("api/OfflineJudge/CopyExecute?" + query_params)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: ResponceDataType) => {
        if (result != null) {
            console.debug(["ExecuteCopyOffLineJudgeFile - ok",result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param settings OfflineJudgeデータリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateDevCombBoxItems = (offlineJudgeData: OfflineJudgeDataType[]) : ComboBoxItemTypeS[]=>{
  let comboItems: ComboBoxItemTypeS[] = [];

  //重複削除
  const unique = offlineJudgeData.filter(
  (element, index, self) => self.findIndex((e) => e.DEV_INDEX === element.DEV_INDEX) === index
);
  unique.forEach((r) => {
    if (r.DEV_INDEX != null) {
    let item: ComboBoxItemTypeS = {
      key :r.DEV_INDEX.toString(),
      name : `${r.DEV_NO} ${r.DEV_NAME}`
    }
    comboItems.push(item);
    }
  });
  return comboItems;
};

/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param settings FileTimeリスト
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateTimeCombBoxItems = (fileTimes: Date[]) : ComboBoxItemTypeS[]=>{
  let comboItems: ComboBoxItemTypeS[] = [];

  fileTimes.forEach((r) => {
    const item: ComboBoxItemTypeS = {
      key :dayjs(r).format('HH:mm:ss'),
      name : dayjs(r).format('HH:mm:ss')
    }
    comboItems.push(item);
  });

  return comboItems;
};
